import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import { PhaseActionType } from "@platform/types/platform.types";

export type Args = {
  quizId: number;
  userId: number | undefined;
  status: "in_progress" | "completed";
  onSuccess?: () => Promise<void>;
  type: PhaseActionType;
};

export function useGetOrCreateQuizResponse({
  quizId,
  userId,
  status,
  onSuccess,
  type,
}: Args) {
  if (["matching_quiz", "meeting_survey"].includes(type)) {
    if (!userId) {
      throw new Error("User ID is required");
    }

    if (!quizId) {
      throw new Error("Quiz ID is required");
    }

    if (!status) {
      throw new Error("Status is required");
    }

    return useMutation({
      mutationFn: async () => {
        const payload = {
          quiz: quizId,
          user: userId,
          status,
        };

        return await apiRequest(`/api/quiz-response/`, "POST", payload);
      },
      onSuccess: () => {
        onSuccess?.();
      },
    });
  }
}

export default useGetOrCreateQuizResponse;
